import { cn } from '@neo/lib/utils'
import { DropdownMenuItem } from '@neo/primitives/dropdown-menu'
import { Tooltip } from '@neo/primitives/tooltip'
import { useCheckTruncated } from '@shared/hooks/use-truncate'
import { useRef } from 'react'
import { useAgentStatusUpdateMutation } from 'v2/pages/settings/org-status/queries'
import { useAppStore } from 'v2/state/app'
import type { ROrgStatus } from 'v2/types/api/settings'

export const StatusItem = ({ s }: { s: ROrgStatus }) => {
  const textRef = useRef<HTMLDivElement>(null)
  const isTruncated = useCheckTruncated(textRef)
  const agentStatus = useAppStore((st) => st.agentStatus)
  const { mutate: updateAgentStatus } = useAgentStatusUpdateMutation()

  const content = (
    <DropdownMenuItem
      key={s.uuid}
      aria-label={`Set status to ${s.status}`}
      data-testid={s.status}
      className={cn('flex items-center gap-2 cursor-pointer', {
        'bg-accent': agentStatus.uuid === s.uuid,
      })}
      onClick={() => {
        updateAgentStatus({
          status_uuid: s.uuid,
          reason_for_change: 'manual update',
        })
      }}
    >
      <div className="h-2 w-2 rounded-full" style={{ background: s.color }} />
      <div className="text-p-400 truncate max-w-[180px]" ref={textRef}>
        {s.status}
      </div>
    </DropdownMenuItem>
  )
  return isTruncated ? <Tooltip content={s.status}>{content}</Tooltip> : content
}
